/*
  PawsLife - Rueckfalloesungen fuer aeltere Browser
  -------------------------------------------------
  Erkennt fehlende Browserfunktionen und gleicht sie aus: fehlendes
  ":has()" wird direkt am Element ausgeglichen, fehlendes "gap" in
  Flexboxen ueber die Klasse "paws-kein-flexgap" an <html> zusammen mit
  assets/paws-fallbacks.css. An der Kauflogik aendert diese Datei nichts -
  sie ergaenzt nur, was aeltere Geraete von sich aus nicht koennen.

  Bewusst in ES5 geschrieben: gerade die Browser, um die es hier geht,
  wuerden modernere Schreibweisen gar nicht erst laden.
*/
(function () {
  'use strict';

  if (window.pawsFallbacks) return;
  window.pawsFallbacks = true;

  var wurzel = document.documentElement;

  function klasseSetzen(name) {
    try {
      if (wurzel.classList) wurzel.classList.add(name);
      else if ((' ' + wurzel.className + ' ').indexOf(' ' + name + ' ') < 0) wurzel.className += ' ' + name;
    } catch (e) {}
  }

  /* 1. window.scrollTo({ top: ... })
     Safari vor 14 kennt das Optionsobjekt nicht, rechnet es zu NaN um und
     springt an den Seitenanfang - der Konfigurator scrollte dann beim
     Schrittwechsel nach ganz oben statt zum naechsten Schritt. */
  try {
    if (!('scrollBehavior' in wurzel.style) && typeof window.scrollTo === 'function') {
      var originalScrollTo = window.scrollTo;
      window.scrollTo = function (a) {
        if (a && typeof a === 'object') {
          var x = typeof a.left === 'number' ? a.left : (window.pageXOffset || 0);
          var y = typeof a.top === 'number' ? a.top : (window.pageYOffset || 0);
          return originalScrollTo.call(window, x, y);
        }
        return originalScrollTo.apply(window, arguments);
      };
    }
  } catch (e) {}

  /* 2. ":has()"
     Ohne Ersatz bliebe am Handy unsichtbar, welches Zusatzprodukt gewaehlt
     ist. Kann der Browser nicht einmal "selector()" pruefen, kennt er auch
     ":has()" nicht - dann greift der Ersatz ebenfalls.
     Die Optik wird direkt am Element gesetzt statt ueber eine Hilfsklasse:
     das ist unabhaengig davon, wie zuverlaessig ein alter Browser eine
     nachtraeglich gesetzte Klasse neu bewertet. */
  var hasFehlt = true;
  try {
    hasFehlt = !(window.CSS && CSS.supports && CSS.supports('selector(:has(*))'));
  } catch (e) {
    hasFehlt = true;
  }

  function akzentfarbe(item) {
    try {
      var wert = getComputedStyle(item).getPropertyValue('--paws-accent');
      if (wert && wert.replace(/\s/g, '')) return wert.replace(/\s/g, '');
    } catch (e) {}
    return '#ff6b35';
  }

  // Werte gespiegelt aus den :has()-Regeln in snippets/paws-configurator.liquid
  function stilFuer(item, gewaehlt) {
    var bundle = (' ' + item.className + ' ').indexOf(' is-bundle ') >= 0;
    if (gewaehlt && bundle) return { border: '2px solid #f39c12', background: '#fff6e2', padding: '9px 11px' };
    if (gewaehlt) return { border: '2px solid ' + akzentfarbe(item), background: '#fff8f4', padding: '9px 11px' };
    if (bundle) return { border: '1px solid #f6d9a6', background: '#fffdf8', padding: '' };
    return { border: '', background: '', padding: '' };
  }

  function upsellsMarkieren() {
    var items = document.querySelectorAll('.paws-addons .paws-upsell-item');
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var stil = stilFuer(item, !!item.querySelector('input:checked'));
      var merker = stil.border + '|' + stil.background + '|' + stil.padding;
      if (item.getAttribute('data-paws-stil') === merker) continue;
      item.setAttribute('data-paws-stil', merker);
      item.style.border = stil.border;
      item.style.background = stil.background;
      item.style.padding = stil.padding;
      // Das Abzeichen ragt oben heraus und braucht Platz darueber.
      item.style.marginTop = item.querySelector('.paws-upsell-badge') ? '9px' : '';
    }
  }

  function hasErsatzStarten() {
    var wartet = false;
    function anstossen() {
      if (wartet) return;
      wartet = true;
      setTimeout(function () {
        wartet = false;
        try { upsellsMarkieren(); } catch (e) {}
      }, 120);
    }

    document.addEventListener('change', anstossen, true);
    document.addEventListener('click', anstossen, true);
    // Nur childList: eigene Stilaenderungen loesen so keine neue Runde aus.
    if (window.MutationObserver && document.body) {
      new MutationObserver(anstossen).observe(document.body, { childList: true, subtree: true });
    }
    anstossen();
  }

  /* 3. "gap" in Flexboxen (Safari vor 14.1)
     In Rastern funktioniert gap laenger als in Flexboxen, deshalb wird
     genau der Flexbox-Fall gemessen statt per @supports geraten. */
  function flexGapVorhanden() {
    if (!document.body) return true;
    var box = document.createElement('div');
    box.style.cssText = 'display:flex;flex-direction:column;row-gap:1px;position:absolute;visibility:hidden;height:auto;';
    box.appendChild(document.createElement('div'));
    box.appendChild(document.createElement('div'));
    document.body.appendChild(box);
    var ok = box.scrollHeight === 1;
    document.body.removeChild(box);
    return ok;
  }

  function starten() {
    if (hasFehlt) {
      try { hasErsatzStarten(); } catch (e) {}
    }
    try {
      if (!flexGapVorhanden()) klasseSetzen('paws-kein-flexgap');
    } catch (e) {}
  }

  if (document.body) starten();
  else document.addEventListener('DOMContentLoaded', starten);
}());
